/*
	AWSClientDetailsApi.ts -- AWS-specific interface to retrieve Client-specific details and platform documentation.
*/

import { CLIENTS, DETAILS, DOCUMENTS, FEATURES, TOGGLE } from 'Config/Paths';
import { ClientDetailsModel, ToggleAdvancedFeaturesRequest } from 'Models/ClientDetailsModel';
import { FileDownloadResponse } from 'Models/Files';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiGet, restApiPost } from 'RestApiConnector';

import { ClientDetailsApi } from './ClientDetailsApi';

export class AWSClientDetailsApi implements ClientDetailsApi {
    getClientDetails = (): Promise<ResponseModel<ClientDetailsModel>> => {
        return restApiGet(`/${CLIENTS}/${DETAILS}`, {});
    };

    getCustomerDocumentation = (fileName: string): Promise<ResponseModel<FileDownloadResponse>> => {
        return restApiGet(`/${DOCUMENTS}/${fileName}`);
    };

    toggleAdvancedFeatures = (request: ToggleAdvancedFeaturesRequest): Promise<ResponseModel<ClientDetailsModel>> => {
        return restApiPost(`/${CLIENTS}/${FEATURES}/${TOGGLE}`, request);
    };
}
